import type { GAEventWithoutCallback } from '@noths/polaris-client-google-analytics';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

import type { Locale, Placement } from 'client-site-chrome-ui/types/locale';
import { setEventCategory } from 'client-site-chrome-ui/utils/setEventCategory';

const currencyEvent = (from: Locale, to: Locale, placement: Placement) => ({
  event: 'custom_event',
  event_action: 'Change currency',
  event_category: setEventCategory(placement),
  event_label: `FROM: ${from.currency} TO: ${to.currency}`,
});

const formatCountry = (locale: Locale) => `${locale.countryCode} - ${locale.deliveryZone}`;

const countryEvent = (from: Locale, to: Locale, placement: Placement) => ({
  event: 'custom_event',
  event_action: 'Change delivery location',
  event_category: setEventCategory(placement),
  event_label: `FROM: ${formatCountry(from)} TO: ${formatCountry(to)}`,
});

export const sendChangeLocaleEvent = async (from: Locale, to: Locale, placement: Placement) => {
  const events: ((Dictionary & Dictionary<GAEventWithoutCallback>) | null)[] = [
    from.currency !== to.currency ? currencyEvent(from, to, placement) : null,
    from.countryCode !== to.countryCode ? countryEvent(from, to, placement) : null,
  ].filter((event) => !!event);

  if (events.length > 0) {
    await sendGAEvent(events as Dictionary & Dictionary<GAEventWithoutCallback>);
    window.location.reload();
  }
};
